// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"753":"4e16a8c5","777":"cc6c8c4f","813":"cb8c26a3"}[chunkId] + ".chunk.css";
};